import { CHARACTER_ACTIONS } from '../Actions/characterActions';
import { log } from "../../Helpers/logger";

const initialState = {
  character: null,
  isLoading: false,
  error: null,
  lastUpdated: null
};

const characterReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHARACTER_ACTIONS.CREATE:
      log.reducer.log('CREATE_CHARACTER action:', action);
      return {
        ...state,
        character: {
          ...action.payload,
          id: action.payload.id || Date.now().toString(),
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        isLoading: false,
        error: null,
        lastUpdated: new Date().toISOString()
      };
      
    case CHARACTER_ACTIONS.UPDATE:
      log.reducer.log('UPDATE_CHARACTER action:', action);
      return {
        ...state,
        character: {
          ...state.character,
          ...action.payload,
          updatedAt: new Date().toISOString()
        },
        isLoading: false,
        error: null,
        lastUpdated: new Date().toISOString()
      };
      
    case CHARACTER_ACTIONS.DELETE:
      log.reducer.log('DELETE_CHARACTER action');
      return {
        ...initialState,
        lastUpdated: new Date().toISOString()
      };
      
    default:
      return state;
  }
};

// Sélecteurs
export const selectCharacter = (state) => state.character.character;
export const selectIsLoading = (state) => state.character.isLoading;
export const selectError = (state) => state.character.error;

export default characterReducer;
